import { ChevronDown } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button, type ButtonVariant } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

export type ReportExportFormat = 'csv' | 'pdf';

interface ReportExportMenuProps {
  disabled?: boolean;
  loading?: boolean;
  format?: ReportExportFormat;
  variant?: ButtonVariant;
  label?: string;
  onExport: (format: ReportExportFormat) => void;
}

export const ReportExportMenu = ({
  disabled,
  loading,
  format,
  variant = 'secondary',
  label,
  onExport,
}: ReportExportMenuProps) => {
  const { t } = useTranslation('reports');
  const { t: tCommon } = useTranslation();
  const triggerLabel = label ?? tCommon('action.export');
  const busyLabel =
    format === 'pdf' ? t('run.exportingPdf') : t('run.exportingSpreadsheet');

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant={variant}
          disabled={disabled}
          loading={loading}
          aria-label={loading ? busyLabel : undefined}
        >
          {triggerLabel}
          <ChevronDown className="size-4" aria-hidden />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem disabled={loading} onClick={() => onExport('csv')}>
          {t('run.exportAsSpreadsheet')}
        </DropdownMenuItem>
        <DropdownMenuItem disabled={loading} onClick={() => onExport('pdf')}>
          {t('run.exportAsPdf')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
